import { AGENCY_VIEW, APP_VIEW, ORG_VIEW } from './constants';
export class Pendo {
    isPendoLoaded() {
        // @ts-ignore
        return !!window.pendo;
    }
    initialize(key) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = `https://cdn.pendo.io/agent/static/${key}/pendo.js`;
        document.head.appendChild(script);
    }
    addUser(config) {
        const { userId, email, name, OnboardingStep, currentApp, currentOrg, currentAgency, isAgencyUser, view, } = config;
        if (!this.isPendoLoaded()) {
            return false;
        }
        const pendoPayload = {
            visitor: {
                id: userId,
                email,
                name,
                OnboardingStep,
                isAgencyUser,
            },
            account: Object.assign({}, this.getBranchEntityIdAndName({
                currentApp,
                currentOrg,
                currentAgency,
                view,
            })),
            disableGuides: true,
        };
        // @ts-ignore
        window.pendo.initialize(pendoPayload);
        return true;
    }
    // eslint-disable-next-line consistent-return
    getBranchEntityIdAndName({ currentApp, currentOrg, currentAgency, view, }) {
        const { current_view: currentView, app_id: branchAppId, organization_id: branchOrgId, } = view;
        if (currentView === APP_VIEW) {
            return {
                id: `app-${branchAppId}`,
                branchAppId,
                appName: currentApp === null || currentApp === void 0 ? void 0 : currentApp.name,
            };
        }
        if (currentView === ORG_VIEW) {
            return {
                id: `org-${branchOrgId}`,
                branchOrgId,
                orgName: currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.name,
            };
        }
        if (currentView === AGENCY_VIEW) {
            return {
                id: `agency-${branchOrgId}`,
                branchAgencyId: branchOrgId,
                agencyName: currentAgency === null || currentAgency === void 0 ? void 0 : currentAgency.organization_name,
            };
        }
    }
    event(eventName, data) {
        if (this.isPendoLoaded() && eventName) {
            // @ts-ignore
            window.pendo.track(eventName, data);
        }
    }
}
//# sourceMappingURL=Pendo.js.map